import React, {CSSProperties, useState} from "react";
import AgentSubmissionLogin from "../../components/project/Agent.submission/Agent.submission.login";
import AgentSignupApi from "../../api/AgentSignup/AgentSignup.api";
import AgentSubmission from "../../components/project/Agent.submission/Agent.submission";
import {
    Button,
    Code,
    Group,
    Paper,
    Stack,
    Text,
    useMantineTheme
} from "@mantine/core";
import {IAgentQuery} from "../../api/Base/Base.types";
import {AlertCircle, Check, Download, X} from "tabler-icons-react";
import {useModals} from "@mantine/modals";

function AgentSubmissionUpdate() {
    const [submission, setSubmission] = useState<any>();
    const [documents, setDocuments] = useState<any>();
    const [submittingForm, setSubmittingForm] = useState(false);
    const modals = useModals();
    const theme = useMantineTheme();

    async function onSubmitLogin(values: any) {
        let submission = await AgentSignupApi.getData({queryKey: ["loadAgent", values]});
        let documents = await AgentSignupApi.getDocuments({queryKey: ["loadAgentDocs", values]});
        if (submission) {
            setSubmission(submission);
        }
        if (documents) {
            setDocuments(documents);
        }
    }

    async function onSubmitQuery(values: IAgentQuery) {
        let res = await AgentSignupApi.updateData({queryKey: ["updateAgentData", values]})
        setSubmittingForm(true);
        let commonModalProps = {
            centered: true,
            withCloseButton:false,
            closeOnClickOutside:false,
            closeOnEscape:false,
            readOnly: true,
        }
        if (res === true) {
            let id = modals.openModal({
                ...commonModalProps,
                title: (
                    <Group spacing="xs">
                        <Check color="#51cf66"/>
                        <Text>Agent Form Updated</Text>
                    </Group>
                ),
                children: (
                    <Stack>
                        <Text size="sm">
                            You have successfully updated your Agent information.
                        </Text>
                        <Button mt={12} color="blue" onClick={() => {
                            modals.closeModal(id)
                        }}>
                            Close
                        </Button>
                    </Stack>
                ),
            })
            setSubmittingForm(false);
            return true;
        } else if (!res || res.errors) {
            modals.openModal({
                ...commonModalProps,
                title: (
                    <Group spacing="xs">
                        <AlertCircle color="#ff6b6b"/>
                        <Text>Error submitting Agent form</Text>
                    </Group>
                ),
                children: (
                    <Stack>
                        <Text size="sm" align="left">
                            Your form <i>could not</i> be submitted due to: <br/>
                            <Text size="sm" color="red">
                                {res.errors.title || res.errors || "No Error Specified"}
                            </Text>
                        </Text>
                        <Text size="sm">
                            If you have gotten this error multiple times please contact support and provide them
                            with this error
                            ID: <br/><Code>{res.errors.traceId || "Agent-Create-No-Error-Code-Specified"}</Code>.
                        </Text>
                    </Stack>

                ),
            })
            setSubmittingForm(false);
            return false;
        }
    }

    if (!submission) {
        return (
            <AgentSubmissionLogin onSubmit={onSubmitLogin}/>
        )
    }

    const commonPaperStyle: CSSProperties = {
        position: 'relative',
        width: "100%",
        backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[7] : theme.white,
        maxWidth: 750,
    }


    return (
        <Paper p="lg" shadow="sm" style={{...commonPaperStyle}}>
            <AgentSubmission onSubmitQuery={onSubmitQuery}
                             initialValues={submission}
                             disableUpdateText
                             isUpdate
                             curDocuments={documents}
            />
        </Paper>
    )
}

export default AgentSubmissionUpdate;